export default "__VITE_ASSET__88ca007c__"